(function () {
  'use strict';

  function initFriendsPartners(root) {
    var gallery = root.querySelector('.fp-gallery');
    if (!gallery) return;

    var cards = Array.prototype.slice.call(gallery.querySelectorAll('.fp-card'));

    cards.forEach(function (card) {
      var playBtn = card.querySelector('.fp-play-btn');
      var video = card.querySelector('.fp-card-video');

      // --- Play / pause inline video ---
      if (playBtn && video) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var playing = card.classList.contains('is-playing');

          // pause any other playing video in the gallery
          cards.forEach(function (c) {
            if (c !== card) {
              var v = c.querySelector('.fp-card-video');
              if (v) v.pause();
              c.classList.remove('is-playing');
            }
          });

          if (playing) {
            video.pause();
            card.classList.remove('is-playing');
          } else {
            card.classList.add('is-playing');
            video.currentTime = 0;
            video.play().catch(function () {
              /* autoplay might be blocked; ignore */
            });
          }
        });

        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
        });
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-fp-section]').forEach(initFriendsPartners);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is loaded/re-rendered in the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-fp-section]');
    if (section) initFriendsPartners(section);
  });
})();
